const props = [
  { prop: 'goodsName', name: '货物名称' },
  { prop: 'goodsCount', name: '货物重量' },
  { prop: 'unit', name: '货物单位' },
  { prop: 'name', name: '货主姓名' },
  { prop: 'phone', name: '货主号码', extra: /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/ },
  { prop: 'provinceFrom', name: '提货地址' },
  { prop: 'cityFrom', name: '提货地址' },
  { prop: 'districtFrom', name: '提货地址', empty: true },
  { prop: 'provinceTo', name: '送达地址' },
  { prop: 'cityTo', name: '送达地址' },
  { prop: 'districtTo', name: '送达地址', empty: true },
];

export default class InquiryOrder {
  constructor() {
    props.forEach(item => {
      this[item.prop] = "";
    })
  }

  validate() {
    const invalid = props.filter(item => (this[item.prop] == '' && !item.empty) || ( item.extra && !item.extra.test(this[item.prop]) && (item.extraFail = true)));
    return invalid;
  }
}


// WEBPACK FOOTER //
// ./src/models/InquiryOrder.js